export const getPricing =
  '<script type="text/javascript" src="https://answeringlegal.formstack.com/forms/js.php/are_pricing"></script><noscript><a href="https://answeringlegal.formstack.com/forms/are_pricing" title="Online Form">Online Form - ARE Pricing</a></noscript>';
